import { formatThousandNumber } from '@utils/utils';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { useEffect, useState } from 'react';
import useReduxState from '@hooks/useReduxState';
import useSocket from '@hooks/useSocket';
import { animated, useTransition } from 'react-spring';

export default function UserBalance({ styles }: { styles: any }): JSX.Element {
    const [user, setUser] = useReduxState((state) => state.userData);
    const [newBalance, setNewBalance] = useState<number>(0);
    const [added, setAdded] = useState<boolean>(true);
    const socket = useSocket();

    const balanceTrans = useTransition(newBalance, {
        config: {
            duration: 600,
        },
        from: {
            bottom: '-20px',
            left: '50%',
            transform: 'translateX(-50%)',
            transition: '1s',
            opacity: 0,
        },
        enter: () => async (next) => {
            await next({
                bottom: '-20px',
                opacity: 1,
            });

            await next({
                bottom: '-15px',
                opacity: 0,
            });
        },
    });

    useEffect(() => {
        let timer: any;
        socket.on(`user-${user.id}`, ({ balance }: { balance: number }) => {
            setUser({
                type: 'CHANGE_USER_BALANCE',
                arg: {
                    balance,
                },
            });
            if (balance < user.balance) {
                setAdded(false);
            } else {
                setAdded(true);
            }
            setNewBalance(user.balance - balance);
        });
        return () => {
            clearTimeout(timer);
        };
    }, [socket, user]);

    return (
        <div className={styles.data__balance}>
            <CoinIcon />
            <span>{formatThousandNumber(user.balance)}</span>
            {balanceTrans((stylesTrans) => (
                <animated.div
                    className={styles.new_balance}
                    style={stylesTrans}
                >
                    {newBalance > 0 && (
                        <>
                            {added ? '+' : '-'}
                            {newBalance}
                        </>
                    )}
                </animated.div>
            ))}
        </div>
    );
}
